@use '../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../styles/Constants.scss' as Constants;

$val-search-field-width: 250px;

.container {
	padding: Constants.$val-spacing-m;
	min-height: 250px;
}

.options {
	display: flex;
	flex-direction: column;
	padding: Constants.$val-spacing-m;

	& > input {
		height: Constants.$val-inputHeight;
		width: $val-search-field-width;
		border: 1px solid Colors.$col-greyMid;
		margin-bottom: Constants.$val-spacing-s;
	}
}

.option {
	padding: Constants.$val-spacing-xs;
	cursor: pointer;
}

.label {
	display: flex;
	flex-direction: row;
}

.loader {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: Constants.$val-spacing-xxl;
}